export const dispatchActions = {
  UPDATE_STATE: 'UPDATE_STATE',
  UPDATE_VOTE: 'UPDATE_VOTE'
}